import { graphql } from "@src/gql";
import { z } from "zod";

export const guestWebSocketTokenQuery = graphql(/* GraphQL */ `
	query GuestWebSocketToken($whiteboardId: String!, $shareKey: String!) {
		guestWebSocketToken(whiteboardId: $whiteboardId, shareKey: $shareKey) {
			token
			expiresAt
			whiteboardId
		}
	}
`);

export const guestWebSocketTokenPayloadSchema = z.object({
	token: z.string().min(1),
	expiresAt: z
		.string()
		.refine(
			(value) => !Number.isNaN(Date.parse(value)),
			"Invalid guest websocket token expiration date",
		),
	whiteboardId: z.string().min(1),
});

export const guestWebSocketTokenQuerySchema = z.object({
	guestWebSocketToken: guestWebSocketTokenPayloadSchema,
});
